import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withLocalize } from 'react-localize-redux'
import { drills } from 'redux/modules'
import PropTypes from 'prop-types'
import Loader from './Loader'

const DrillLoader = (props) => {
  const {
    children,
    drillUuid,
    fetchDrill,
    activeLanguage: { code: locale },
    ...restProps
  } = props

  return (
    <Loader
      fetchMethod={() => fetchDrill(drillUuid, { locale })}
      triggers={[locale]}
      {...restProps}
    >
      {children}
    </Loader>
  )
}

DrillLoader.propTypes = {
  children: PropTypes.node.isRequired,
  drillUuid: PropTypes.string.isRequired,
  fetchDrill: PropTypes.func.isRequired,
  activeLanguage: PropTypes.shape({
    code: PropTypes.string.isRequired,
  }).isRequired,
}

export default compose(
  connect(null, { fetchDrill: drills.fetchDrill }),
  withLocalize
)(DrillLoader)
